import React from 'react'
import { Helmet } from 'react-helmet'
import { strings } from 'js/strings'

const Seo = ({ page }) => {
  const companyName = strings.company
  const pageTitle = page && page.title ? page.title : ''
  const seo = {
    title: page?.seo?.title,
    description: page?.seo?.description,
    keywords: page?.seo?.keywords,
  }
  const setTitle = seo.title ? seo.title : `${pageTitle} - ${companyName}`
  return (
    <Helmet>
      <title>{setTitle}</title>
      {seo.description && <meta name='description' content={seo.description} />}
      {seo.keywords && <meta name='keywords' content={seo.keywords} />}
    </Helmet>
  )
}

export default Seo
